import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCurrentAdmin } from '../hooks/useCurrentAdmin';
import type { AdminRole } from '../types/api';

interface RoleGuardProps {
  allow: AdminRole[];
  redirectTo?: string;
  children: React.ReactNode;
}

const RoleGuard: React.FC<RoleGuardProps> = ({ allow, redirectTo = '/home', children }) => {
  const { role } = useCurrentAdmin();
  if (!role || !allow.includes(role)) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
};

export default RoleGuard;
